import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';
import sellerStatisticService from '../../../services/seller/statistics';
import moment from 'moment';

const initialState = {
  loading: false,
  sales: [],
  error: '',
  params: {
    time: 'subMonth',
  },
};

// Helper function to build API params with proper priority
const buildApiParams = (params = {}) => {
  const apiParams = { ...params };
  
  // If date_from is provided, use date range and remove time
  if (apiParams.date_from) {
    apiParams.date_to = apiParams.date_to || moment().format('YYYY-MM-DD');
    delete apiParams.time;
  } else if (!apiParams.time) {
    // Default to subMonth if neither date_from nor time is provided
    apiParams.time = 'subMonth';
  }
  
  return apiParams;
};

export const fetchOrderSales = createAsyncThunk(
  'statistics/fetchOrderSales',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return statisticService.ordersCount(apiParams).then((res) => res);
  }
);
export const fetchSellerOrderSales = createAsyncThunk(
  'statistics/fetchSellerOrderSales',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return sellerStatisticService.ordersCount(apiParams).then((res) => res);
  }
);

const orderSalesSlice = createSlice({
  name: 'orderSales',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOrderSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrderSales.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.sales = payload?.data || [];
      state.error = '';
    });
    builder.addCase(fetchOrderSales.rejected, (state, action) => {
      state.loading = false;
      state.sales = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchSellerOrderSales.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerOrderSales.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.sales = payload?.data || [];
      state.error = '';
    });
    builder.addCase(fetchSellerOrderSales.rejected, (state, action) => {
      state.loading = false;
      state.sales = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterOrderSales(state, action) {
      const { payload } = action;
      state.params = payload;
    },
  },
});
export const { filterOrderSales } = orderSalesSlice.actions;
export default orderSalesSlice.reducer;
